import { Mail, MessageCircle } from "lucide-react";

// wa.me exige solo dígitos con prefijo de país, sin +/espacios/guiones. Si el número no trae ya
// un prefijo de país (asumimos España, +34, si tiene 9 dígitos justos) se lo añadimos — es lo
// que hay en la inmensa mayoría de los teléfonos que se dan de alta en el panel.
function whatsappHref(telefono: string): string {
  const digits = telefono.replace(/\D/g, "");
  const conPrefijo = digits.length === 9 ? `34${digits}` : digits;
  return `https://wa.me/${conPrefijo}`;
}

function gmailHref(email: string): string {
  return `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(email)}`;
}

// Botones de contacto directo (whatsapp/email) — se usan en clubes, proveedores, jugadores...
// cualquier ficha con teléfono y/o email. No hace falta ninguna integración: son enlaces
// directos que abren WhatsApp Web/la app y Gmail ya con el destinatario puesto.
export function ContactButtons({ telefono, email, size = "sm" }: { telefono?: string | null; email?: string | null; size?: "sm" | "md" }) {
  if (!telefono && !email) return null;
  const dims = size === "sm" ? "h-7 w-7" : "h-9 w-9";
  const iconDims = size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";

  return (
    <span className="inline-flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
      {telefono && (
        <a
          href={whatsappHref(telefono)}
          target="_blank"
          rel="noreferrer"
          title={`WhatsApp: ${telefono}`}
          className={`flex items-center justify-center rounded-full bg-emerald-50 text-emerald-600 transition-colors hover:bg-emerald-100 ${dims}`}
        >
          <MessageCircle className={iconDims} />
        </a>
      )}
      {email && (
        <a
          href={gmailHref(email)}
          target="_blank"
          rel="noreferrer"
          title={`Escribir a ${email}`}
          className={`flex items-center justify-center rounded-full bg-red-50 text-red-500 transition-colors hover:bg-red-100 ${dims}`}
        >
          <Mail className={iconDims} />
        </a>
      )}
    </span>
  );
}
